<template>
    <div class="home">

        <div class="creppy-white-blass-wait">
            <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">LabyHelp Befehle</h5>

            <br class="no-move"/>

        </div>

        <div class="main-title">

            <br class="no-move"/>
            <br class="no-move"/>

            <p class="text-normal-title">Hier siehst du alle aktuellen LabyHelp Befehle.</p>

            <br class="no-move"/>
            <hr class="container"/>
            <br class="no-move"/>

            <p class="smaller-end-text container">
                <strong>Spieler:</strong>
                - /lhbandana [Spieler]
                - /lhcape [Spieler]
                - /lhskin [Spieler]
                - /lhvoicechat
                - /lhreport [Spieler]
                - /lhtarget list oder /lhtarget add [Spieler] [Größe], /lhtarget remove [Spieler]
            </p>
             <p class="footnote-text text-white-gray-color">Um LabyHelp Spieler spezifische Befehle auszuführen.</p>

            <br class="no-move"/>
            <hr class="container"/>
            <br class="no-move"/>

            <p class="smaller-end-text container">
                <strong>Soziale Netzwerke:</strong>
                - /social [Spieler]
                </p>
            <p class="footnote-text text-white-gray-color">Um die verknüpften Social Medias zu sehen.</p>

            <br class="no-move"/>
            <hr class="container"/>
            <br class="no-move"/>

            <p class="smaller-end-text container">
                <strong>Liken, Inviten:</strong>
                - /lhlike [Spieler]
                - /lhlikes
                - /likelist
                - /lhinvites [Spieler]
                - /invitelist
                - /lhcode [Spieler]
                </p>

            <p class="footnote-text text-white-gray-color">Um die LabyHelp Likes oder Invites zu sehen.</p>

            <br class="no-move"/>
            <hr class="container"/>
            <br class="no-move"/>

            <p class="smaller-end-text container">
                <strong>LabyHelp:</strong>
                - /lhteam
                - /lhaddons
                - /lhrules
                - /lhreload
                - /lhsupport
                - /labyhelp
                - /lhpartner oder /lhpartner [Server]
                - /lhbadge
                - /labyhelpid
            </p>

            <p class="footnote-text text-white-gray-color">Um allgemeine Informationen zu erhalten.</p>

            <br class="no-move"/>
            <hr class="container"/>
            <br class="no-move"/>

            <div class="container">

                <h1 class="headers-text text-dark"><strong>Informationen</strong></h1>
                <p class="smaller-end-text text-dark">
                Um auf die Befehle zugreifen zu können. Musst du die neuste LabyHelp Version besitzten. Um zu überprüfen welche Version die besitzt nutze "/labyhelp" und folge den Schritten im Chat.
                </p>

            </div>

            <br class="no-move"/>

            <div class="" style="alignment: bottom">

                <div class="" style="alignment: bottom">
                    <p class="smaller-end-text">© {{ today.getFullYear() }}
                        <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/support">Support</a>
                        -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/apply">Apply</a>
                        -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/creator">Creator</a>
                        -
                        <a style="color: #6868b3"
                           href="ts3server://labyhelp.de">TeamSpeak</a>
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "Team",
    data() {
        return {
            today: new Date()
        }
    },
}
</script>

<style scoped>

</style>